import React, { Component } from 'react';
import * as NavLinks from './NavLinks'

import './styles/Header.css'
import CSSTransition from 'react-transition-group/CSSTransition'
import {Link} from 'react-router-dom'

class Header extends Component {
    constructor(props) {
        super(props);
        this.state={
            nav: false,
        }
        this.renderHeader = this.renderHeader.bind(this)
        this.renderMobileHeader = this.renderMobileHeader.bind(this)
        this.renderMobileNav = this.renderMobileNav.bind(this)

        this.handleNavButtonClick = this.handleNavButtonClick.bind(this)
    }
    render() {
        const { media, isProjectView } = this.props

        let headerStyle = {}

        if(isProjectView){
            headerStyle = { position: 'relative', }
        }

        if(media !== 'MOBILE'){
            return (
                <header style={headerStyle} className="Header ">
                    {this.renderHeader()}
                </header>
            )
        }else{
            return (
                <header style={headerStyle} className="Header border-bottom">
                    {this.renderMobileNav()}
                    {this.renderMobileHeader()}
                </header>
            )
        }
    }

    renderHeader(){
        return(
        <div className="row">
            <nav className="col col-6">
                <h3 className="PageTitle bold">{NavLinks.HomeNavLink}</h3>
            </nav>
            <nav className="col col-6">
                {NavLinks.ArtNavLink}<br/>
                {NavLinks.ComNavLink}
            </nav>
            <div className="Header__AboutLink small-type">
                {NavLinks.AboutNavLink}
            </div>
        </div>
        )
    }

    renderMobileHeader(){
        return(
        <div className="row" onClick={this.handleNavButtonClick}>
            <div className="col col-12">
                <h3 className="PageTitle bold black-type">Julian Salinas Fotografie</h3>
                <div className="NavButton button clickable">
                    {this.state.nav?<i className="icon icon-fw icon-Close"/>:<i className="icon icon-fw icon-Nav"/>}
                </div>
            </div>
        </div>
        )
    }

    renderMobileNav(){
        return(
            <CSSTransition
                   in={this.state.nav}
                   timeout={300}
                   classNames="slideY"
                   mountOnEnter={true}
                   unmountOnExit={true}
                >
                <nav className="MobileNav">
                    <div className="MobileNavLink border-bottom" onClick={this.handleNavButtonClick}>{NavLinks.ArtNavLink}</div>
                    <div className="MobileNavLink border-bottom" onClick={this.handleNavButtonClick}>{NavLinks.ComNavLink}</div>
                    <div className="MobileNavLink border-bottom" onClick={this.handleNavButtonClick}>{NavLinks.AboutNavLink}</div>
                    <div className="MobileNavLink small-type" onClick={this.handleNavButtonClick}><Link to="/">Home </Link></div>
                </nav>
            </CSSTransition>
        )
    }

    // Events:
    handleNavButtonClick(){
        this.setState({nav:!this.state.nav})
    }
}



export default Header



// WEBPACK FOOTER //
// ./src/Header.js